module.exports = __webpack_public_path__ + "static/introVideo-e98abdac6c467ad24aee64344b78e4ad.mp4";